<template>
  <div class="container-fluid mt-nav mb-5 mb-chat site-width">
    <div class="d-flex flex-wrap align-items-center">
      <b-breadcrumb :items="breadcrumbs" class="basecrumb d-print-none"/>
      <SearchSimple class="ml-auto" :value="query.search" @submit="query = {...query, search: $event}"/>
    </div>
    <h1 class="mb-4">Projects</h1>
    <ProjectsWidget
      :key="$route.fullPath"
      :query.sync="query"
    />
  </div>
</template>

<script>
import ProjectsWidget from '@/pages/projects/-widget.vue'
import SearchSimple from '@/components/SearchSimple.vue'

export default {
  name: 'ProjectsList',
  components: {
    ProjectsWidget,
    SearchSimple,
  },
  computed: {
    breadcrumbs() {
      return [
        {text: '🏠', to: '/'},
        {text: 'Projects', active: true},
      ]
    },
    query: {
      get() {
        return this.$route.query
      },
      set(query) {
        this.$router.push({query})
      },
    },
  },
}
</script>
